import { createThunkRoutine } from 'redux-thunk-routine';
import { FETCH_AUDIT_DATA } from './action-types';

export const FetchAuditLogRoutine = createThunkRoutine(FETCH_AUDIT_DATA);
